import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { Observable, Subject, take, takeUntil } from 'rxjs';

import { IPaperCopyrightData } from 'editing-tool/src/app/shared/components/paper/steps/copyright/paper-copyright-data';
import { FileResponse } from 'sc-common';
import { ApiPaperCopyright, ApiPaperCopyrightSubmit, CopyrightStatusEnum } from 'sc-common/core/services/open-api/main-api-client';

@Component({
    selector: 'et-paper-copyright',
    templateUrl: './paper-copyright.component.html',
    standalone: false
})
export class PaperCopyrightComponent implements OnInit, OnDestroy {

    @Input()
    public data: IPaperCopyrightData;

    @Input()
    public isReadonly: boolean;

    @Output()
    public readonly copyrightAccepted = new EventEmitter();

    public model: ApiPaperCopyright;

    public requestInProcess = false;

    public download$: Observable<FileResponse>;

    private readonly _destroy$ = new Subject<void>();

    public ngOnInit(): void {

        this.data.copyright$
            .pipe(takeUntil(this._destroy$))
            .subscribe(apiModel => this.model = apiModel);

        this.download$ = this.data.copyrightFile$;
    }

    public ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    public acceptCopyright(formValue: ApiPaperCopyrightSubmit): void {

        this.requestInProcess = true;

        this.data.create(formValue)
            .pipe(take(1), takeUntil(this._destroy$))
            .subscribe({
                next: apiModel => {
                    this.model = apiModel;
                    this.copyrightAccepted.emit();
                    this.requestInProcess = false;
                },
                error: () => {
                    this.requestInProcess = false;
                }
            });
    }

    public isAbsentCopyright(copyrightStatus: CopyrightStatusEnum): boolean {
        return copyrightStatus === CopyrightStatusEnum.None;
    }
}
